export const ProductTypeEnum = [
    { id: 'basic', name: 'Basic' },
    { id: 'fabric', name: 'Fabric' },
    { id: 'sample', name: 'Sample' },
    { id: 'sample_book', name: 'Sample Book' },
    { id: 'wallpaper', name: 'Wallpaper' },
];